import { FooterLinks } from "component_old/macro/layout/footer/FooterLinks"
import { MainButton, S_MainButton } from "component_old/micro/action/MainButton"
import { ImageMask } from "component_old/micro/design/ImageMask"
import {
    S_DesktopOnly,
    S_MobileOnly,
} from "component_old/micro/responsive/responsive"
import { SVG_Logo, S_SVG_Logo } from "libs/images/SVG_Logo"
import { Localization } from "libs/localization/localization"
import { EColors, EGrads, EShadows } from "libs/style/styling"
import { EScrolls, scrollToAnchor } from "libs/utils/logic/browserLogic"
import React from "react"
import styled from "styled-components/macro"

export const Footer = (): JSX.Element => {
  const SubheaderPc = Localization.TITLE3 + " " + Localization.TITLE4
  const SubheaderMobile = (
    <>
      {Localization.TITLE3}
      <br /> {Localization.TITLE4}
    </>
  )

  return (
    <S_Wrap>
      <S_Footer>
        <S_Content>
          <S_MobileOnly>
            <ImageMask
              positionX="center"
              positionY="bottom -225px"
              image="planet"
              step={0}
              degress={0}
              initOpacity={1}
              finalOpacity={1}
              repeat={false}
              size="contain"
            />
          </S_MobileOnly>
          <S_DesktopOnly>
            <ImageMask
              positionX="center"
              positionY="bottom -920px"
              image="planet"
              step={0}
              degress={0}
              initOpacity={1}
              finalOpacity={0.5}
              repeat={false}
              size="1260px"
            />
          </S_DesktopOnly>
          <S_MobileOnly>
            <S_FooterHeading>{SubheaderMobile}</S_FooterHeading>
          </S_MobileOnly>
          <S_DesktopOnly>
            <S_FooterHeading>{SubheaderPc}</S_FooterHeading>
          </S_DesktopOnly>
          <S_Buttons>
            <MainButton
              text={Localization.CREATE_MAP_ACTION}
              type="primary"
              shadow={EShadows.STRONG}
              onClick={() => {
                window.location.href = "https://app.mapheim.com"
              }}
            />
            <MainButton
              text={Localization.GET_EXPERT_ACTION}
              type="secondary"
              onClick={() => {
                scrollToAnchor(EScrolls.contact)
              }}
            />
          </S_Buttons>
          <SVG_Logo />
          <FooterLinks />
        </S_Content>
      </S_Footer>
    </S_Wrap>
  )
}

const S_Wrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const S_FooterHeading = styled.div`
  color: ${EColors.WHITE};
  font-family: "InterBold";
  font-size: 29px;
  line-height: 41px;
  letter-spacing: -0.03em;
  @media only screen and (min-width: 1260px) {
    font-size: 42px;
    line-height: 60px;
  }
`

export const S_Footer = styled.div`
  padding: 20px 20px 50px 20px;
  background: ${EGrads.PRIM_GRAD};
  position: relative;
  width: 100%;
  margin: 75px 0 0 0;
  display: flex;
  justify-content: center;
  ${S_FooterHeading} {
    text-align: center;
    margin: 40px 0 40px;
  }
  ${S_SVG_Logo} {
    margin: 0 0 25px 0;
    svg {
      width: 135px;
      height: auto;
    }
  }
  @media only screen and (min-width: 1260px) {
    margin: 100px 0 0 0;
    padding: 20px 20px 40px 20px;
    ${S_FooterHeading} {
      margin: 100px 0 60px;
    }
    ${S_SVG_Logo} {
      margin: 40px 0 45px 0;
      svg {
        width: 170px;
      }
    }
  }
`

const S_Content = styled.div`
  width: 100%;
  @media only screen and (min-width: 1260px) {
    max-width: 1260px;
  }
`

const S_Buttons = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 0 50px 0;
  ${S_MainButton}:nth-child(1) {
    margin: 0 10px 0 0;
  }
  ${S_MainButton}:nth-child(2) {
    margin: 0 0px 0 10px;
  }
  @media only screen and (min-width: 1260px) {
    margin: 0 0 130px 0;
  }
`
